<mcg-loader [message]="translate('Cargando_datos')" [showLoader]="isLoading"></mcg-loader>

<jqxWindow #formWindow jqxWindowAutoResize [theme]="environment.tema"
  [zIndex]="900" [autoOpen]="true" [showCloseButton]="true" [showCollapseButton]="true" [minHeight]="380" [minWidth]="620"
  [resizable]="true" [title]="translate('Rango')" (onClose)="onClose()">
  <div class="formHeader" style="overflow-x: hidden;">
  </div>

  <div class="form" style="float: left; overflow-x: hidden;">
    <div class="row" style="height: calc(100% - 20px); overflow-y: auto; overflow-x: hidden;">
      <span style="width: 100%;">
        <div style="height: 100%; width: 100%;">
          <fieldset class="row">
            <div style="display: flex; justify-content: flex-start; width: 50%;">
              <div style="display: flex; flex-direction: column; width: 100%;">
                <span style="width: 100%; clear: both;">
                  <div>
                    {{ translate('Descripcion') }}
                  </div>
                  <jqxInput [(ngModel)]="rango.nombre" [width]="'100%'">
                  </jqxInput>
                </span>

                <div class="row mt-5-px">
                  <span>
                    <div>
                      {{ translate('Tarjeta_inicial') }} (ID)
                    </div>
                    <jqxNumberInput #inputTarjetaIni
                      [min]="1"
                      [width]="'50%'"
                      [decimalDigits]="0"
                      [inputMode]="'simple'"
                      [value]="rango.idTarjetaInicial"
                      title="{{rango.idTarjetaInicial}}"
                      (onChange)="changeTarjetaInicial($event.args.value)"
                    >
                    </jqxNumberInput>
                  </span>

                  <span>
                    <div>
                      {{ translate('Cantidad') }}
                    </div>
                    <jqxNumberInput #inputTotalTarjetas
                      [min]="1"
                      [width]="'30%'"
                      [decimalDigits]="0"
                      [inputMode]="'simple'"
                      [value]="totalTarjetas"
                      (onChange)="changeTotalTarjetas($event.args.value)"
                    >
                    </jqxNumberInput>
                  </span>

                  <span>
                    <div>
                      {{ translate('Tarjeta_final') }} (ID)
                    </div>
                    <jqxNumberInput #numericInput
                      [disabled]="true"
                      [width]="'50%'"
                      [decimalDigits]="0"
                      [inputMode]="'simple'"
                      [value]="rango.idTarjetaFinal"
                      title="{{rango.idTarjetaFinal}}"
                    >
                    </jqxNumberInput>
                  </span>
                </div>

                <div class="row">
                  <span style="width: 100%; clear: both;">
                    <div style="margin-top: 5px">
                      {{ translate('Tipo') }}
                    </div>

                    <div class="row mt-5-px">
                      <span>
                        <jqxRadioButton (onChange)="setLista($event.args.checked, 'Blanca')"
                        [height]="25" [checked]="rango.listaBlanca">
                          <span>{{ translate('Blanca') }}</span>
                        </jqxRadioButton>
                      </span>

                      <span>
                        <jqxRadioButton (onChange)="setLista($event.args.checked, 'Master')"
                        [height]="25" [checked]="rango.listaMaster">
                          <span>{{ translate('Masters') }}</span>
                        </jqxRadioButton>
                      </span>

                      <span>
                        <jqxRadioButton (onChange)="setLista($event.args.checked, 'Negra')"
                        [height]="25" [checked]="rango.listaNegra">
                          <span>{{ translate('Negra') }}</span>
                        </jqxRadioButton>
                      </span>
                    </div>
                  </span>
                </div>
              </div>
            </div>

            <div class="tables-wrapper">
              <div class="grid-container">
                  <div class="grid-header">
                    {{ translate('Zonas_libres') }}
                  </div>
                  <jqxGrid #gridZonas [theme]="environment.tema" [width]="'100%'" [height]="'100%'" [filterrowheight]='30'
                    [source]="adapterZona" [columnsresize]="false" [localization]="langGrid" [filterable]="true" [showfilterrow]="true"
                    [columns]="columnsZonas" [showrowlines]="false" [showcolumnlines]="true" [pageable]="false" [sortable]="true"
                    [altrows]="true" [showstatusbar]="false" [statusbarheight]="0" [enablebrowserselection]="true" [showaggregates]="false"
                    [rowsheight]="15" [columnsheight]="20" [enabletooltips]="false" [editable]="false" [groupable]="false" [selectionmode]="'singlerow'"
                    (onRowdoubleclick)="associateZonaTarjeta()">
                  </jqxGrid>
                </div>

                <div class="botonesAsignacion">
                  <jqxButton class="button" style="cursor: pointer;" [width]="25" [height]="25" [imgHeight]="15"
                    [imgWidth]="15" [imgSrc]='"/assets/images/derecha.png"' [imgPosition]="'center'"
                    (onClick)="associateZonaTarjeta()">
                  </jqxButton>
                  <jqxButton class="button" style="cursor: pointer;" [width]="25" [height]="25" [imgHeight]="15"
                    [imgWidth]="15" [imgSrc]='"/assets/images/izquierda.png"' [imgPosition]="'center'"
                    (onClick)="disassociateZonaTarjeta()">
                  </jqxButton>
              </div>

              <div class="grid-container">
                  <div class="grid-header">
                    {{ translate('Zonas_seleccionadas') }}
                  </div>
                  <jqxGrid #gridZonasToAsign [theme]="environment.tema" [width]="'100%'" [height]="'100%'"
                    [filterrowheight]='30' [source]="adapterZonaToAsign" [columnsresize]="false"
                    [localization]="langGrid" [filterable]="true" [showfilterrow]="true" [columns]="columnsZonas"
                    [showrowlines]="false" [showcolumnlines]="true" [pageable]="false" [sortable]="true"
                    [altrows]="true" [showstatusbar]="false" [statusbarheight]="0" [enablebrowserselection]="true"
                    [showaggregates]="false" [rowsheight]="15" [columnsheight]="20" [enabletooltips]="false"
                    [editable]="false" [groupable]="false" [selectionmode]="'singlerow'"
                    (onRowdoubleclick)="disassociateZonaTarjeta()">
                  </jqxGrid>
                </div>
              </div>
          </fieldset>
        </div>
      </span>
    </div>

    <div style="position: absolute; bottom: 5px; left: 0px; margin-top: 5px;
      clear: both;">
      <jqxButton style="float: left; margin-left: 5px" [width]="100" [height]="26"
        [textImageRelation]="'imageBeforeText'" [textPosition]="'left'" [imgSrc]="'/assets/images/save.png'"
        (onClick)="onGuardar()" [value]="translate('Guardar')">
      </jqxButton>

      <jqxButton style="float: left; margin-left: 5px" [width]="100" [height]="26"
        [textImageRelation]="'imageBeforeText'" [textPosition]="'left'"
        (onClick)="closeWindow()" [value]="translate('CANCELAR')">
      </jqxButton>
    </div>
  </div>
</jqxWindow>
